import $ from "jquery";
import Screen from "@bd-utils/screen";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";
import TeamConnector from "@bd-utils/team-connector";
import Debriefing from "@bd-utils/debriefing";
import fb from "@bd-core/firebase";
import { getState, subscribe } from "@bd-stores/store";
import GameLogic from "@bd-core/game-logic";
import html2canvas from "@wtto00/html2canvas"; // Use this fork version to fix object-fit issue


export const ResultPage = () => {
    const isResultPage = $("#result-page").length > 0;
    if (!isResultPage) return false;

    const elms = {
        goToDebrief: "#debrief",
        teamConnector: ".teamconnector",
        debriefing: ".debriefing",
        proceedRestart: ".js-restart-game",
        shareButton: ".js-share-button",
        backBtn: ".js-result-back",
    };

    const renderAfterInitialized = () => {
        let hasRendered = false;

        subscribe(() => {
            const store = getState();
            if (!store.userProgress.isFirebaseInitialized) return;
            if (store.gameProgress.players.length < 1) return;
            if (hasRendered) return;

            hasRendered = true;
            Screen.calculateFitSize();
            $(window).on("resize", () => Screen.calculateFitSize());
            $(".app__page").addClass("result-loaded");

            /* Initialize Debriefing */
            if ($(elms.debriefing).length) {
                new Debriefing().init();
            }

            /* Initialize Team-connector */
            if ($(elms.teamConnector).length) {
                new TeamConnector().init();
            }
        });
    };

    renderAfterInitialized();
    GameLogic.listenGameProgressChanged();

    //----------------------------------------------------------------------- Initialize Firebase
    try {
        fb.initializeGame();
    } catch (e) {
        console.error(e);
    }

    let isLoading = false;

    const showAfterGameContent = () => {
        if ($(elms.debriefing).length) {
            $(".resultPage").addClass("is-debriefing");
            return;
        }

        if ($(elms.teamConnector).length) {
            $(elms.teamConnector).addClass("is-active");
            return;
        }
    };

    const restartGame = async (e) => {
        const $this = $(e.currentTarget);
        if (isLoading) return;
        $this.addClass("is-loading");
        isLoading = true;

        const [res] = await bdjs.goAsync(bdapi.post("game/restart-game"));
        const resData = res?.data || {};

        if (resData?.data?.redirect) {
            bdjs.showLoading();
            $(".transitionPage").show();
            setTimeout(
                () => window.location.replace(resData.data.redirect),
                1000,
            );
            return;
        }

        isLoading = false;
        $this.removeClass("is-loading");
    };

    const goToPrevPage = () => {
        $("#result-page").removeClass("is-debriefing");
    };

    const shareResult = async () => {
        try {
            const $el = $("#result-page");
            await document.fonts.ready;
            const canvas = await html2canvas($el[0], {
                scale: 2,
                useCORS: true,
                logging: false,
                ignoreElements: (element) => {
                    // Exclude share and replay buttons
                    return element.classList.contains('js-share-button') || 
                            element.classList.contains('js-restart-game') ||
                            element.closest('.resultPage__action') !== null;
                },
            });

            const croppedCanvas = document.createElement("canvas");
            const ctx = croppedCanvas.getContext("2d");
            croppedCanvas.width = canvas.width;
            croppedCanvas.height = canvas.height;
            ctx.drawImage(
                canvas,
                0,
                0,
                canvas.width,
                croppedCanvas.height,
                0,
                0,
                croppedCanvas.width,
                croppedCanvas.height,
            );

            croppedCanvas.toBlob(
                (blob) => {
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `result.jpg`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                },
                "image/jpeg",
                0.95,
            );
        } catch (error) {
            console.error("Error generating download:", error);
        }
    };

    $(elms.goToDebrief).on("click", showAfterGameContent);
    $(elms.proceedRestart).on("click", restartGame);
    $(elms.backBtn).on("click", goToPrevPage);
    $(elms.shareButton).on("click", shareResult);
};
